function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11 13l-5.5.75L11.917.917 11 9l5.5-.75-6.417 12.833L11 13z"
});
function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none"
  }, props), _ref);
}
export default SvgLightning;